import Registry from "../helpers/Registry";
import ImageLoader from "./ImageLoader";

export default class Rotator {
    static get(selector) {
        var instance = Registry.get(selector);

        if (instance) return instance;

        instance = new Rotator(selector);
        Registry.set('Rotator', selector, instance);
        return instance;
    }

    constructor(selector) {
        if (typeof selector === 'string')
            this.obj = $(selector);
        else
            this.obj = selector;

        this.color = {};
        this.color.container = this.obj.find('.color-list');
        this.color.items = this.obj.find('.color-list__item');
        this.color.info = this.obj.find('[rotator-info]');

        this.defaults = {
            color: this.obj.data('color') ? (parseInt(this.obj.data('color')) - 1) : 0,
            info: 'Цвет: <span>$color$</span>'
        };

        this.image = {};
        this.image.container = this.obj.find('.image__rotator');
        this.image.main = this.image.container.find('img:not(.cache)');

        this.arrows = this.obj.find('[rotator-arrow]');

        this.i();

        return this;
    }

    i() {
        this.setActive(this.defaults.color);
        this.setEvents();
        return this;
    }

    loadImages(index) {
        this.image.container.find('.cache').remove();
        this.colors = this.color.items.eq(index).data('img');
        const self = this,
            path = (window.prefix ? window.prefix : '');

        this.colors = path + this.colors;

        this.append().then(() => {
            self.image.main.attr('src', self.colors);
        });

        return this;
    }

    async append() {
        const self = this;
        ImageLoader.preload(self.colors)
            .then(() => {return true})
            .catch(() => {
                console.warn('Error in loading: ' + self.colors);
            })
    }


    setActive(index) {
        const item = this.color.items.eq(index);
        this.active = index;
        this.color.items.removeClass('active');
        this.color.info.html(this.defaults.info.replace('$color$', item.data('name')));
        item.addClass('active');
        this.loadImages(index);
    }

    setEvents() {
        const self = this;

        self.color.items.on('click', function (e) {
            e.preventDefault();
            self.setActive($(this).index());
        });

    }
}